import { Commit, ActionTree, MutationTree, Dispatch } from 'vuex';
import actions from './topoGroup.actions';
import mutations from './topoGroup.mutations';
import getters from './topoGroup.getters';

export interface Group {
  id: string;
  name: string;
  apps: Array<{ key: string; label: string }>;
}
export interface State {
  groupId: string;
  groups: Group[];
}

const initState: State = {
  groupId: 'all',
  groups: []
};

export default {
  namespaced: true,
  state: initState,
  actions: actions,
  mutations,
  getters
};
